import Navbar from 'react-bootstrap/Navbar'
import { Link } from 'react-router'

export default function HeaderLogo() {
    return (
        <Navbar.Brand>
            <Link to={"/"} reloadDocument>
                <img src="/tpl/assets/img/romerobject.svg" alt="ROMER" height="22" />
            </Link>
        </Navbar.Brand>
    )
}